import Idly from '../assets/idly.jpg';
import Poori from '../assets/poori.jpg';
import Rice from '../assets/rice.jpg';
import Briyani from '../assets/briyani.jpg';
import BucketBriyani from '../assets/bucketbriyani.jpeg';
import Dosa from '../assets/dosa.jpeg';
import LemonRice from '../assets/lemonrice.jpg';
import Muthuidly from '../assets/muthuidly.jpg';
import Muthusapathi from '../assets/sapathi.jpg';
import Muthupaniyaram from '../assets/paniyaram.jpg';
import Muthudosa from '../assets/muthudosa.jpg';
import Muthuragikali from '../assets/muthuragikali.jpg';
import Muthuvegrice from '../assets/muthuvegrice.jpg';
import Malligavegrice from '../assets/malligavegrice.jpg';
import Muthuchickenrice from '../assets/muthuchickenrice.jpg';
import Muthuparotta from '../assets/muthuparotta.jpg';
import Muthunoodles from '../assets/muthunoodles.jpg';
import Muthuraagiidly from '../assets/muthuraagiidli.jpg';
import Malligameals from '../assets/malligameals.png';
import Malligavadai from '../assets/malligavadai.jpg';
import Muthukothuparotta from '../assets/muthkothuparotta.jpg';
import Muthuamlet from '../assets/muthuamlet.jpg';
import BulkIceCream from '../assets/bulkicecream.jpg';
import Milk from '../assets/aromamilk1.png';
import kiwi1 from '../assets/NewUpdates/kiwi-1.jpeg'
import kiwi2 from '../assets/NewUpdates/kiwi-2.jpeg'
import kiwi3 from '../assets/NewUpdates/kiwi-3.jpeg'
import kiwi4 from '../assets/NewUpdates/kiwi-4.jpeg'
import kiwi5 from '../assets/NewUpdates/kiwi-5.jpeg'
import kiwi6 from '../assets/NewUpdates/kiwifp-6.jpeg'
import kiwi7 from '../assets/NewUpdates/kiwi-dream-7.jpeg'
import mercely1 from '../assets/NewUpdates/mercely-bar.jpeg'
import mercely2 from '../assets/NewUpdates/mercely-cone.jpeg'
import mercely3 from '../assets/NewUpdates/mercely-cone.jpeg'
import mercely4 from '../assets/NewUpdates/mercely-FP.jpeg'
import mercely5 from '../assets/NewUpdates/mercely-fp1.jpeg'
import mercely6 from '../assets/NewUpdates/mercely-starwberry.jpeg'
import mercely7 from '../assets/NewUpdates/mercely.jpeg'
import mercely8 from '../assets/NewUpdates/mercelymango-fp.jpeg'
import mercely9 from '../assets/NewUpdates/merry-berry.jpeg'
/*export const data = [

    {
        id: 1,
        name: 'Idly',
        category: 'Steamed',
        shopName: 'Malliga Mess',
        shopEmail:"yaazhbatch1@gmail.com",
        image: Idly,
        price: 20,
        description: 'Idli is a traditional South Indian dish renowned for its light, fluffy texture and nutritional benefits. Made from a fermented batter of rice and urad dal (black gram), idli is a steamed food that is both wholesome and easy to digest. The batter is poured into round molds and steamed to produce soft, cake-like discs.'
    },
    {
        id: 2,
        name: 'Dosa',
        category: 'Spoiled',
        shopName: 'Malliga Mess',
        shopEmail:"yaazhbatch1@gmail.com",
        image: Dosa,
        price: 20,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 3,
        name: 'Poori',
        category: 'Fried Food',
        shopName: 'Malliga Mess',
        shopEmail:"yaazhbatch1@gmail.com",
        image: Poori,
        price: 20,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 4,
        name: 'Lemon Rice',
        category: 'Fried',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: LemonRice,
        price: 50,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 5,
        name: 'Rice',
        category: 'Steamed',
        shopName: 'Malliga Mess',
        shopEmail:"yaazhbatch1@gmail.com",
        image: Rice,
        price: 80,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 6,
        name: 'Briyani',
        category: 'Boiled',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Briyani,
        price: 120,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 7,
        name: 'Idly',
        category: 'Boiled',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthuidly,
        price: 15,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 8,
        name: 'Sapathi',
        category: 'Fried',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthusapathi,
        price: 23,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 9,
        name: 'Paniyaram',
        category: 'Fried',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthupaniyaram,
        price: 5,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 10,
        name: 'Dosa',
        category: 'Fried',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthudosa,
        price: 18,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 11,
        name: 'Ragi kali',
        category: 'Spoiled',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthuragikali,
        price: 30,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 12,
        name: 'Veg Rice',
        category: 'Fried',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthuvegrice,
        price: 100,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 13,
        name: 'Veg Rice',
        category: 'Fried',
        shopName: 'Malliga Mess',
        shopEmail:"yaazhbatch1@gmail.com",
        image: Malligavegrice,
        price: 90,
        description: 'Idli is a traditional South Indian dish renowned for its light, fluffy texture and nutritional benefits. Made from a fermented batter of rice and urad dal (black gram), idli is a steamed food that is both wholesome and easy to digest. The batter is poured into round molds and steamed to produce soft, cake-like discs.'
    },
    {
        id: 14,
        name: 'Chilli Chicken',
        category: 'Fried',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthuchickenrice,
        price: 100,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 15,
        name: 'Parotta',
        category: 'Stemed',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthuparotta,
        price: 20,
        description: 'Àmàlà is a Nigerian food made out of yamflour. Yams are peeled, sliced, cleaned, dried and then blended into a flour, also called elubo. Yams are white in colour but turn brown when dried; this gives àmàlà its colour. Àmàlà is from Western Africa and eaten mostly by the Yoruba people in Nigeria. This food can be consumed with ewedu (jute) and stew (made from pepper, tomato, palm oil, water). The full health benefits of this kind of meal is good for the wellbeing of humans.rich in a lot of health benefits including aiding weight loss and lowering cancer risks'
    },
    {
        id: 16,
        name: 'Noodles',
        category: 'Swallow',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthunoodles,
        price: 70,
        description: 'Pounded Yam is a staple in many West African homes, but it is not usually eaten by itself, it is often paired with many delicious African soups, and stews like Egusi, okra soup, Jute leaves soup (Ewedu), or Stewed Spinach (Efo Riro). If you are new to this food, I’ll explain. Pounded is quite similar to mashed potatoes but it has a more doughy consistency. It belongs to a group of food we refer to as swallow because of the way we eat it. We cut out a morsel from the meal,  then we form an indentation on it with the thumb. Then, we scoop some stew or soup over it and we eat it.'
    },
    {
        id: 17,
        name: 'Meals',
        category: 'Spoiled',
        shopName: 'Malliga Mess',
        shopEmail:"yaazhbatch1@gmail.com",
        image: Malligameals,
        price: 80,
        description: 'Pounded Yam is a staple in many West African homes, but it is not usually eaten by itself, it is often paired with many delicious African soups, and stews like Egusi, okra soup, Jute leaves soup (Ewedu), or Stewed Spinach (Efo Riro). If you are new to this food, I’ll explain. Pounded is quite similar to mashed potatoes but it has a more doughy consistency. It belongs to a group of food we refer to as swallow because of the way we eat it. We cut out a morsel from the meal,  then we form an indentation on it with the thumb. Then, we scoop some stew or soup over it and we eat it.'
    },
    {
        id: 18,
        name: 'Vadai',
        category: 'Oil Spoiled',
        shopName: 'Malliga Mess',
        shopEmail:"yaazhbatch1@gmail.com",
        image: Malligavadai,
        price: 7,
        description: 'Pounded Yam is a staple in many West African homes, but it is not usually eaten by itself, it is often paired with many delicious African soups, and stews like Egusi, okra soup, Jute leaves soup (Ewedu), or Stewed Spinach (Efo Riro). If you are new to this food, I’ll explain. Pounded is quite similar to mashed potatoes but it has a more doughy consistency. It belongs to a group of food we refer to as swallow because of the way we eat it. We cut out a morsel from the meal,  then we form an indentation on it with the thumb. Then, we scoop some stew or soup over it and we eat it.'
    },
    {
        id: 19,
        name: 'Raagi Idly',
        category: 'Swallow',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthuraagiidly,
        price: 12,
        description: 'Pounded Yam is a staple in many West African homes, but it is not usually eaten by itself, it is often paired with many delicious African soups, and stews like Egusi, okra soup, Jute leaves soup (Ewedu), or Stewed Spinach (Efo Riro). If you are new to this food, I’ll explain. Pounded is quite similar to mashed potatoes but it has a more doughy consistency. It belongs to a group of food we refer to as swallow because of the way we eat it. We cut out a morsel from the meal,  then we form an indentation on it with the thumb. Then, we scoop some stew or soup over it and we eat it.'
    },
    {
        id: 20,
        name: 'Kothu Parotta',
        category: 'Swallow',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthukothuparotta,
        price: 60,
        description: 'Pounded Yam is a staple in many West African homes, but it is not usually eaten by itself, it is often paired with many delicious African soups, and stews like Egusi, okra soup, Jute leaves soup (Ewedu), or Stewed Spinach (Efo Riro). If you are new to this food, I’ll explain. Pounded is quite similar to mashed potatoes but it has a more doughy consistency. It belongs to a group of food we refer to as swallow because of the way we eat it. We cut out a morsel from the meal,  then we form an indentation on it with the thumb. Then, we scoop some stew or soup over it and we eat it.'
    },
    {
        id: 21,
        name: 'Amlet',
        category: 'Swallow',
        shopName: 'Muthu Mess',
        shopEmail:"rajappansellamuthu@gmail.com",
        image: Muthuamlet,
        price: 20,
        description: 'Pounded Yam is a staple in many West African homes, but it is not usually eaten by itself, it is often paired with many delicious African soups, and stews like Egusi, okra soup, Jute leaves soup (Ewedu), or Stewed Spinach (Efo Riro). If you are new to this food, I’ll explain. Pounded is quite similar to mashed potatoes but it has a more doughy consistency. It belongs to a group of food we refer to as swallow because of the way we eat it. We cut out a morsel from the meal,  then we form an indentation on it with the thumb. Then, we scoop some stew or soup over it and we eat it.'
    },
    
]*/

export const data = [

    
    {
        id: 1,
        name: '4 Ltr Premium Cheese Strawberry',
        category: 'bulkIceCream',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: BulkIceCream,
        price: 250,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 2,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: Milk,
        price: 60,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 3,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: kiwi1,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 4,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: kiwi2,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 5,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: kiwi3,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: kiwi4,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: kiwi5,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: kiwi6,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: kiwi7,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely1,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely2,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely3,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely4,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely5,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely6,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely7,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely8,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    {
        id: 6,
        name: 'Milk',
        category: 'milk',
        shopName: 'HARE KRISHNA TRADERS',
        shopEmail: "aykaruppukidaivirundhu@gmail.com",
        offer: '50',
        image: mercely9,
        price: 30,
        offerPrice: 75,
        description: 'A delightful feast featuring Chicken Biryani with tender, flavorful leg pieces cooked in aromatic basmati rice and Indian spices, accompanied by a rich and spicy gravy to enhance the experience. The meal is perfectly complemented with crispy and tangy Chicken 65, offering a burst of spices in every bite. For a refreshing touch, theres creamy Onion Raita with finely chopped onions and a hint of cumin. Finally, indulge in the sweet and creamy Carrot Payasam, a dessert made from grated carrots, milk, ghee, and garnished with nuts and cardamom, leaving you with a satisfying end to the meal'
    },
    
    

]
export const category = [
 
    {
        id: 1,
        category: 'Ice Cream',

    },
    {
        id: 2,
        category: 'Milk',

    },
    //    {
    //  id: 3,
    //  category: 'Briyani',

    // },
]

export const categories = [
    {
        id: 1,
        name: 'Ice Cream',
        image:
            'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/FastFood_BrowseHome@3x.png',
    },
    {
        id: 2,
        name: 'Milk',
        image:
            'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/Pizza_BrowseHome@3x.png',
    },
    {
        id: 3,
        name: 'Wings',
        image:
            'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/Wings_BrowseHome@3x.png',
    },
    {
        id: 4,
        name: 'Indian',
        image:
            'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/Indian_BrowseHome@3x.png',
    },
    {
        id: 5,
        name: 'Latest Deals',
        image:
            'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/Deals_BrowseHome@3x.png',
    },
    {
        id: 6,
        name: 'Daily Rewards',
        image:
            'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/RestoRewards_BrowseHome@3x.png',
    },
    {
        id: 7,
        name: 'Best Overall',
        image:
            'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/TopEats_Browse%20Home@3x.png',
    },
    {
        id: 8,
        name: 'Shipped Free',
        image:
            'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/Placeholder_Plates@3x.png',
    },
];